"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  keyframes: [{
    transform: "translate3d(-100%, 0, 0)",
    opacity: 0
  }, {
    transform: "translate3d(0, 0, 0)",
    opacity: 1
  }],
  timing: {
    duration: 1000,
    fill: "both"
  }
};